import { useState } from "react"
import Button from "@/components/Button"
import { useGame } from "@/hooks/useGame"
import { Modals, useModals } from "@/hooks/useModals"
import ActionsDropdown from "./ActionsDropdown"
import { useGameMoves } from "@/hooks/useGameMoves"
import { router, usePage } from "@inertiajs/react"
import { GameShowProps } from "@/types/types"
import useDeleteGame from "@/hooks/useDeleteGame"

const ActionBar = () => {
  const { game } = usePage<GameShowProps>().props
  const { id } = game

  const { openModal } = useModals()
  const { isDraft, isEdited } = useGame()
  const { movesHistory, discardChanges } = useGameMoves()
  const [processing, setProcessing] = useState(false)

  const { deleteGame, processing: deleteProcessing } = useDeleteGame()

  const handleCancel = () => {
    const needsConfirmation = movesHistory?.length > 0

    const confirmation = needsConfirmation
      ? confirm("Are you sure you want to discard this draft?")
      : true

    if (!confirmation) return

    deleteGame(id)
  }

  const handleSave = () => {
    router.patch(
      `/games/${id}`,
      { game: { moves: movesHistory as any } },
      {
        async: true,
        preserveState: true,
        preserveScroll: true,
        replace: true,
        only: ["game"],
        onStart: () => setProcessing(true),
        onSuccess: () => {
          if (isDraft) openModal(Modals.SaveGame)
        },
        onFinish: () => setProcessing(false),
      }
    )
  }

  return (
    <div className="flex items-center gap-x-1.5">
      {isDraft ? (
        <>
          <Button
            size="sm"
            onClick={handleCancel}
            style="secondary"
            loading={deleteProcessing}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            onClick={handleSave}
            loading={processing}
            disabled={!movesHistory?.length || deleteProcessing}
          >
            Done entering moves
          </Button>
        </>
      ) : isEdited ? (
        <>
          <Button
            size="sm"
            onClick={discardChanges}
            style="secondary"
            disabled={processing}
          >
            Discard changes
          </Button>
          <Button size="sm" onClick={handleSave} loading={processing}>
            Save changes
          </Button>
        </>
      ) : (
        <>
          <ActionsDropdown />
          <Button
            size="sm"
            onClick={() => openModal(Modals.SaveGame)}
            style="secondary"
          >
            Edit
          </Button>
          <Button
            size="sm"
            onClick={() => openModal(Modals.Share)}
            disabled={deleteProcessing}
          >
            Share game
          </Button>
        </>
      )}
    </div>
  )
}

export default ActionBar
